let loadingTimer: number = 0;

/** 应用内全局对象 */
export const global: Record<string, any> = {};

/** 全局 weekMap 对象 */
export const weekGlobal = new WeakMap();

/**
 * 弹出全局 toast 提示，timeout 为超时时间，单位 ms，默认 2500ms
 */
export function toast(text: string, timeout: number = 2500) {
  const div = document.createElement("div");
  div.setAttribute(
    "style",
    `position:fixed;z-index:2002;left:0;top:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;`
  );
  div.innerHTML = `<div class="global-toast" style="display:inline-block;padding:10px 20px;background:rgba(0,0,0,.7);color:#fff;border-radius:10px;text-align:center">${text}</div>`;
  document.body.appendChild(div);
  setTimeout(() => {
    document.body.removeChild(div);
  }, timeout);
}

export const loading = {
  html: SY_LoadingHTML,
  show() {
    if (loadingTimer) {
      return;
    }
    addLoading()
    // loadingTimer = window.setTimeout(addLoading, 100);
  },
  hide() {
    loadingTimer && window.clearTimeout(loadingTimer);
    loadingTimer = 0;
    removeLoading();
  },
};

function addLoading() {
  const div = document.createElement("div");
  div.id = "global-loading-box"; // 对应loading模板中的覆盖样式
  div.innerHTML = SY_LoadingHTML;
  document.body.appendChild(div);
}

function removeLoading() {
  const dom = document.getElementById("global-loading-box");
  if (dom) {
    document.body.removeChild(dom);
  }
}
